import React from "react";
import SelectedEntitiesProvider from "views/components/contexts/SelectedMessageEntitiesProvider";
import useSelectableLogViewMessages from "logview/components/contexts/useSelectableLogViewMessages";
const LogViewSelectedEntitiesProvider = ({ children = null, bulkSelection = null }) => {
  const { selectableLogViewMessages } = useSelectableLogViewMessages();
  return /* @__PURE__ */ React.createElement(
    SelectedEntitiesProvider,
    {
      initialSelection: bulkSelection == null ? void 0 : bulkSelection.initialSelection,
      onChangeSelection: bulkSelection == null ? void 0 : bulkSelection.onChangeSelection,
      entities: selectableLogViewMessages
    },
    children
  );
};
export default LogViewSelectedEntitiesProvider;
